import { render, staticRenderFns } from "./UmpdCreate.vue?vue&type=template&id=06a6797f&"
import script from "./UmpdCreate.vue?vue&type=script&lang=js&"
export * from "./UmpdCreate.vue?vue&type=script&lang=js&"
import style0 from "./UmpdCreate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports